/**
 * Soft Forest Night halo behind small dusk text. Invisible on the night canvas itself;
 * it only darkens the glowing meadow right behind the letters while copy scrolls
 * through it, so muted text keeps its contrast. A shadow, not a glow: same hue as the bg.
 */
export const HALO = '[text-shadow:0_0_16px_rgba(15,29,22,0.95),0_0_5px_rgba(15,29,22,0.85)]';
